<template>
  <div class="admin-pagination">
    <button
      class="admin-page-btn"
      :disabled="currentPage <= 1"
      @click="onPageChange(currentPage - 1)"
    >
      &lsaquo;
    </button>
    <template v-for="page in displayPages" :key="page">
      <span v-if="page === '...'" class="admin-page-ellipsis">...</span>
      <button
        v-else
        :class="['admin-page-btn', { active: page === currentPage }]"
        @click="onPageChange(page)"
      >
        {{ page }}
      </button>
    </template>
    <button
      class="admin-page-btn"
      :disabled="currentPage >= totalPages"
      @click="onPageChange(currentPage + 1)"
    >
      &rsaquo;
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  currentPage: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    required: true,
  },
  onPageChange: {
    type: Function,
    required: true,
  },
})

const displayPages = computed(() => {
  const total = props.totalPages
  const current = props.currentPage
  const pages = []

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i)
    return pages
  }

  pages.push(1)

  if (current > 3) {
    pages.push('...')
  }

  const start = Math.max(2, current - 1)
  const end = Math.min(total - 1, current + 1)
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  if (current < total - 2) {
    pages.push('...')
  }

  pages.push(total)

  return pages
})
</script>

<style scoped>
.admin-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
}

.admin-page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--line);
  border-radius: var(--radius);
  background: var(--bg-panel);
  color: var(--text-main);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.15s;
}

.admin-page-btn:hover:not(:disabled):not(.active) {
  background: var(--bg-soft);
  border-color: var(--line-strong);
}

.admin-page-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
}

.admin-page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.admin-page-ellipsis {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  color: var(--text-muted);
  font-size: 13px;
}
</style>
